import { render, staticRenderFns } from "./Badge14.vue?vue&type=template&id=395af810&scoped=true"
import script from "./Badge14.vue?vue&type=script&lang=js"
export * from "./Badge14.vue?vue&type=script&lang=js"
import style0 from "./Badge14.vue?vue&type=style&index=0&id=395af810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395af810",
  null
  
)

export default component.exports